export class TransactionsModel{
trtype = '' ;
trserial = '' ;
trdate = '2022-01-01' ;
trkind = '' ;
trvalue = 0 ;
trchno = '' ;
trchduedate = '2022-01-01' ;
trcln_supp = '' ;
supname ='';
trbank = '' ;
trclass = '' ;
trdoctor = '' ;
trhospital = '' ;
trdescription = '' ;
compcode = '' ;
userid = '' ;
modifieddate = '2022-01-01' ;


}
